import Layout from "@/components/Layout";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { PHONE, PHONE_HREF, ADDRESS_LINE } from "@/lib/api";

export default function Contact() {
  return (
    <Layout>
      <section className="mx-auto max-w-6xl px-4 sm:px-8 py-16">
        <div className="eyebrow mb-2">Contact</div>
        <h1 className="hero-title text-4xl sm:text-5xl text-white">Call the shop. Text a photo. Send it in.</h1>

        <div className="mt-10 grid md:grid-cols-2 gap-10">
          <div className="space-y-6">
            <a href={PHONE_HREF} data-testid="contact-phone" className="shop-card p-6 flex items-center gap-4 hover:border-red-500 transition">
              <div className="w-14 h-14 bg-red-600/15 border border-red-600/40 flex items-center justify-center rounded-sm">
                <Phone className="w-6 h-6 text-red-500" />
              </div>
              <div>
                <div className="eyebrow">Call / Text</div>
                <div className="font-display font-black text-3xl text-white">{PHONE}</div>
              </div>
            </a>
            <div className="shop-card p-6 flex items-center gap-4">
              <div className="w-14 h-14 bg-red-600/15 border border-red-600/40 flex items-center justify-center rounded-sm">
                <MapPin className="w-6 h-6 text-red-500" />
              </div>
              <div>
                <div className="eyebrow">Shop</div>
                <div className="font-display font-black text-xl text-white">{ADDRESS_LINE}</div>
                <div className="text-slate-400 text-sm">Drop-off by appointment</div>
              </div>
            </div>
            <div className="shop-card p-6 flex items-center gap-4">
              <div className="w-14 h-14 bg-red-600/15 border border-red-600/40 flex items-center justify-center rounded-sm">
                <Clock className="w-6 h-6 text-red-500" />
              </div>
              <div>
                <div className="eyebrow">Hours</div>
                <div className="text-white font-display font-bold">Mon–Fri 6:30a – 5:30p</div>
                <div className="text-white font-display font-bold">Sat by appointment</div>
                <div className="text-red-500 text-sm mt-1">24/7 emergency line via on-site request</div>
              </div>
            </div>
          </div>

          <div className="shop-card overflow-hidden p-2">
            <iframe
              title="Shop location"
              className="w-full h-[420px] rounded-sm"
              loading="lazy"
              src="https://www.openstreetmap.org/export/embed.html?bbox=-85.6,37.15,-85.4,37.35&layer=mapnik&marker=37.2617,-85.4914"
            />
          </div>
        </div>
      </section>
    </Layout>
  );
}
